import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { PhoneIcon } from '@svgs'
import { Button } from 'src/components/ui'
import { IProperty } from 'src/interfaces/IProperty'
import { useRevealContactMutation } from 'src/redux/api'

interface IContactRevealButton {
  property: IProperty
}

// Contacts-on-request (roadmap 41 B1). Shown to a logged-in viewer who is not
// the owner while the phone is still hidden. Auto-reveal listings unlock it on
// tap; otherwise the tap queues a request the owner must approve. Once the
// phone is visible (canSeeContacts), AgentInfo renders the tel: button itself
// and this component steps aside.
const ContactRevealButton: FC<IContactRevealButton> = ({ property }) => {
  const { t } = useTranslation()
  const [reveal, { isLoading }] = useRevealContactMutation()

  if (property.canSeeContacts) return null

  if (property.contactRevealStatus === 'PENDING') {
    return (
      <div className="w-full rounded-xl bg-warning-soft px-3 py-2.5 text-sm font-bold text-warning text-center">
        {t('contact.pending')}
      </div>
    )
  }

  const label = property.autoRevealContacts ? t('contact.show') : t('contact.request')

  return (
    // outlined like the phone number it opens (the green fill carried white
    // text at 3.3:1)
    <Button
      type="button"
      variant="outlined"
      disabled={isLoading}
      onClick={() => reveal(property.id)}
      className="w-full"
      icon={<PhoneIcon />}
    >
      {label}
    </Button>
  )
}

export default ContactRevealButton
